import React, { useEffect, useState } from 'react';

import { FetchError } from '../api/api';

export interface ErrorMetadata {
  type: string;
  data: Record<string, any>;
}

export interface ErrorMetadataViewProps<T extends ErrorMetadata> {
  error?: FetchError & { metadata?: T };
}

export interface ErrorMetadataPluginProps<T extends ErrorMetadata> {
  error: FetchError & { metadata: T };
  children?: React.ReactNode;
  onCancel: () => void;
}

export interface ErrorMetadataPlugin<T extends ErrorMetadata> {
  type: T['type'];
  render: React.FC<ErrorMetadataPluginProps<T>>;
}

export function createErrorMetadataView<T extends ErrorMetadata>(
  ...plugins: ErrorMetadataPlugin<T>[]
): React.FC<ErrorMetadataViewProps<T>> {
  return props => {
    const { error: errorProp, children } = props;
    const [error, setError] = useState(errorProp);
    const { metadata } = error || {};
    const plugin =
      metadata && plugins.find(plugin => plugin.type === metadata.type);

    useEffect(() => {
      errorProp && setError(errorProp);
    }, [errorProp]);
    if (!plugin || !error?.metadata) {
      return <></>;
    }

    const pluginProps: ErrorMetadataPluginProps<T> = {
      children,
      error: error as any,
      onCancel: () => setError(undefined)
    };
    return <plugin.render {...pluginProps} />;
  };
}
